"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  NuqsTestingAdapter: true,
  withNuqsTestingAdapter: true
};
Object.defineProperty(exports, "NuqsTestingAdapter", {
  enumerable: true,
  get: function () {
    return _testing.NuqsTestingAdapter;
  }
});
Object.defineProperty(exports, "withNuqsTestingAdapter", {
  enumerable: true,
  get: function () {
    return _testing.withNuqsTestingAdapter;
  }
});
var _nuqs = require("nuqs");
Object.keys(_nuqs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _nuqs[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _nuqs[key];
    }
  });
});
var _custom = require("nuqs/adapters/custom");
Object.keys(_custom).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _custom[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _custom[key];
    }
  });
});
var _testing = require("nuqs/adapters/testing");
